import { render, staticRenderFns } from "./smsLogs.vue?vue&type=template&id=3dd517e0&scoped=true"
import script from "./smsLogs.vue?vue&type=script&lang=js"
export * from "./smsLogs.vue?vue&type=script&lang=js"
import style0 from "./smsLogs.vue?vue&type=style&index=0&id=3dd517e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd517e0",
  null
  
)

export default component.exports